import React from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "../dashboard/main/MainLayout";
import Dashboard from "../dashboard/warehouse/ScanorprintBarcode/Dashboard";
import Singleitem from "../dashboard/warehouse/ScanorprintBarcode/Singleitem";
import Assemblyitems from "../dashboard/warehouse/ScanorprintBarcode/Assemblyitems";
import BarcodeDetails from "../dashboard/warehouse/ScanorprintBarcode/BarcodeDetails";
import PrintbarcodeBatches from "../dashboard/warehouse/ScanorprintBarcode/PrintbarcodeBatches";
import PrintbarcodeBoxes from "../dashboard/warehouse/ScanorprintBarcode/PrintbarcodeBoxes";
import GoodsDashboard from "../dashboard/warehouse/GoodsInOut/GoodsDashboard";
import GoodsInDetails from "../dashboard/warehouse/GoodsInOut/GoodsInDetails";
import WarehouseList from "../dashboard/warehouse/Warehouses/WarehouseList";
import Warehouse from "../dashboard/warehouse/Warehouses/Dashboard"
import SupplierListTableData from "../dashboard/warehouse/suppliers/SupplierListTableData";
import SupplierDetails from "../dashboard/warehouse/suppliers/supplier-details/GeneralDetails"
import AddWarehouse from "../dashboard/warehouse/Warehouses/AddWarehouse";
const warehouseDashboard = () => (
  <>

      <Route path="/dashboard" element={<MainLayout />}>

      <Route path="/dashboard/warehouse/printscan" element={<Dashboard />} />
      <Route path="/dashboard/warehouse/printscan/single-item" element={<Singleitem />} />
      <Route path="/dashboard/warehouse/printscan/assembly" element={<Assemblyitems />} />
      <Route path="/dashboard/warehouse/goodsInout" element={<GoodsDashboard />} />
      <Route path="/dashboard/warehouse/goodsInout/goodsin-details" element={<GoodsInDetails />} />
      <Route path="/dashboard/warehouse/warehouse-list" element={<WarehouseList />} />
      <Route path="/dashboard/warehouse/warehouse-list/warehouse-details" element={<Warehouse />} />
      <Route path="/dashboard/warehouse/warehouse-list/Add-warehouse" element={<AddWarehouse />} />

      <Route path="/dashboard/warehouse/supplier" element={<SupplierListTableData />} />
      <Route path="/dashboard/warehouse/supplier/supplier-details" element={<SupplierDetails />} />



      <Route path="/dashboard/warehouse/printscan/barcode-details" element={<BarcodeDetails />} />
      <Route path="/dashboard/warehouse/printscan/printbarcode-batches-items" element={<PrintbarcodeBatches />} />
      <Route path="/dashboard/warehouse/printscan/printbarcode-batches-boxes" element={<PrintbarcodeBoxes />} />





      </Route>

  </>
);

export default warehouseDashboard;
